<ng-container *ngIf="award?.standart_card">
  <app-standart-card-award [award]="award"></app-standart-card-award>
</ng-container>

<ng-container *ngIf="award?.named_card">
  <app-named-card-award [award]="award"></app-named-card-award>
</ng-container>

<ng-container *ngIf="award?.certificate">
  <app-certificate-award [award]="award"></app-certificate-award>
</ng-container>
